import React from 'react';
import { Tooltip, ResponsiveContainer, Treemap } from 'recharts';
import { methodGatewaysNameFormatting } from 'utils/constant';

const COLORS = ['#53A366', '#8CCC43', '#52C41A', '#8CCC43', '#06b6d4', '#a855f7', '#84cc16'];

const CustomContent = (props) => {
  const { x, y, width, height, name, value, index, totalCount } = props;
  const color = COLORS[index % COLORS?.length];

  return (
    <g>
      <rect x={x} y={y} width={width} height={height} fill={color} stroke='#fff' strokeWidth={2} />
      {width > 100 && height > 40 && (
        <>
          <text x={x + width / 2} y={y + height / 2 - 6} textAnchor='middle' fill='#fff' fontSize={13} fontWeight={300}>
            {methodGatewaysNameFormatting[name] || name}
          </text>
        </>
      )}
      {width > 50 && height > 20 && (
        <text x={x + width / 2} y={y + height / 2 + 12} textAnchor='middle' fill='#fff' fontSize={11} fontWeight={300}>
          {((value / totalCount) * 100).toFixed(2)}%
        </text>
      )}
    </g>
  );
};

const PaymentTreeMapChart = ({ data, type }) => {
  return (
    <>
      {type === 'methods' && (
        <ResponsiveContainer width='100%' height={400}>
          <Treemap
            style={{ width: '100%', maxWidth: '300px', maxHeight: '80vh', aspectRatio: 4 / 3 }}
            content={(props) => <CustomContent totalCount={data?.totalCount} {...props} />}
            data={data?.methods}
            dataKey='value'
            aspectRatio={4 / 3}
            stroke='#fff'
            fill='#53A366'>
            <Tooltip
              formatter={(value) => (
                <>
                  {value.toLocaleString()} ({((value / data?.totalCount) * 100).toFixed(2)}%)
                </>
              )}
            />
          </Treemap>
        </ResponsiveContainer>
      )}
      {type === 'gateways' && (
        <ResponsiveContainer width='100%' height={400}>
          <Treemap
            style={{ width: '100%', maxWidth: '300px', maxHeight: '80vh', aspectRatio: 4 / 3 }}
            content={(props) => <CustomContent totalCount={data?.totalCount} {...props} />}
            data={data?.gateways}
            dataKey='value'
            aspectRatio={4 / 3}
            stroke='#fff'
            fill='#53A366'>
            <Tooltip
              formatter={(value) => (
                <>
                  {value.toLocaleString()} ({((value / data?.totalCount) * 100).toFixed(2)}%)
                </>
              )}
            />
          </Treemap>
        </ResponsiveContainer>
      )}
    </>
  );
};

export default PaymentTreeMapChart;
